import { action, computed, makeObservable, observable } from "mobx";
import React from "react";

export interface Tab {
  title: React.ReactNode;
  id: string;
  key: string | number;
  content: React.ReactNode;
}

class TabedDataTableStore {
  _tabs: Tab[];
  _activeId?: string | null;
  constructor() {
    this._tabs = [];
    this._activeId = null;
    makeObservable(this, {
      _tabs: observable,
      _activeId: observable,
      setTabs: action,
      addTab: action,
      tabs: computed,
      activeId: computed,
      setActiveId: action,
    });
  }

  setTabs(tabs: Tab[]): void {
    this._tabs = tabs;
  }

  addTab(tab: Tab): void {
    this._tabs.splice(-1, 0, tab);
  }

  get tabs(): Tab[] {
    return this._tabs;
  }

  setActiveId(activeId: string): void {
    this._activeId = activeId;
  }

  get activeId(): string | null {
    return this._activeId || null;
  }
}

const tabedDataTableStore = new TabedDataTableStore();

export default tabedDataTableStore;
